module.exports = __webpack_public_path__ + "editor/icon-designer-cc220029e4b52d6bb7c0f8124b457e3d.svg";